/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_In_SpotInputs */

const en_status_in_spot = /** @type {(inputs: Status_In_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Spot`)
};

const es_status_in_spot = /** @type {(inputs: Status_In_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En bodega`)
};

/**
* | output |
* | --- |
* | "In Spot" |
*
* @param {Status_In_SpotInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_in_spot = /** @type {((inputs?: Status_In_SpotInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_In_SpotInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_in_spot(inputs)
	return es_status_in_spot(inputs)
});